import React, { useEffect } from 'react'
import { Switch, List, Ellipsis } from 'antd-mobile'
import { getPersonalDetailValue } from 'api/api'
import { TRUE_FLAG_NUM } from 'utils/constant'
import "static/css/serviceApply.css"

const ConditionCheckListItem = ({ item, titleItem, onItemChange }) => {

  const { valueName, disabled, type } = titleItem

  const { value, conditionItem, determine } = item

  useEffect(() => {
    if (conditionItem) {
      getPersonalDetailValue(conditionItem, determine).then(res => {
        const { value } = res || {}
        value && onItemChange(value === TRUE_FLAG_NUM, item, type)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <List.Item
      extra={
        <Switch
          checked={value === TRUE_FLAG_NUM}
          onChange={(value) => onItemChange(value, item, type)}
          disabled={disabled} />
      }
    >
      <Ellipsis
        rows={2}
        direction='end'
        content={item[valueName]}
        expandText='展开'
        collapseText='收起'
      />
    </List.Item>
  )
}

export { ConditionCheckListItem }